export function SliderArrow(props) {
  return (
    <svg width="44" height="44" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <circle cx="22" cy="22" r="22" fill="white"/>
      <path d="M12 22L19 15V29L12 22Z" fill="#444444"/>
      <path d="M32 22L25 29L25 15L32 22Z" fill="#444444"/>
    </svg>
  )
}